interface Breakpoints {
  width: number;
  resolution: string;
}
interface ContentfulImageOptions {
  url?: string;
  title?: string;
  format?: string;
  queries?: string[];
  breakpoints?: Breakpoints[];
}

function createUrl(
  url: string,
  format: string,
  width: number,
  queries: string[]
) {
  let res = `${url}?fm=${format}&q=90&w=${width.toString()}`;
  queries.forEach((item) => (res += `&${item}`));

  return res;
}

function createSrcSet(
  url: string,
  format: string,
  breakpoints: Breakpoints[],
  queries: string[]
) {
  return breakpoints
    .map(
      (breakpoint) =>
        `${createUrl(url, format, breakpoint.width, queries)} ${
          breakpoint.resolution
        }`
    )
    .join(', ');
}

function createImageSet(
  url: string,
  format: string,
  breakpoints: Breakpoints[],
  queries: string[]
) {
  return breakpoints
    .map(
      (breakpoint) =>
        `url("${createUrl(url, format, breakpoint.width, queries)}") ${
          breakpoint.resolution
        }`
    )
    .join(', ');
}

export function useContentfulImage({
  url,
  title = '',
  format = 'jpg',
  queries = [],
  breakpoints = [{ width: 1200, resolution: '1x' }],
}: ContentfulImageOptions) {
  if (typeof url === 'undefined') return undefined;
  return {
    src: createUrl(url, format, breakpoints[0].width, queries),
    srcSet: createSrcSet(url, format, breakpoints, queries),
    imageSet: createImageSet(url, format, breakpoints, queries),
    alt: title,
  };
}
